"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueQueryFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const QueryFieldKey_1 = __importDefault(require("../QueryFieldKey"));
exports.IssueQueryFields = {
    [QueryFieldKey_1.default.ISSUE_CREATED_BY_ME]: {
        key: QueryFieldKey_1.default.ISSUE_CREATED_BY_ME,
        fieldType: BasicFieldType_1.default.BOOLEAN,
        label: () => lib_i18n_1.default.t('show-created-by-me'),
        hidden: true,
    },
    [QueryFieldKey_1.default.ISSUE_CREATEDBY]: {
        key: QueryFieldKey_1.default.ISSUE_CREATEDBY,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('reporter'),
    },
    [QueryFieldKey_1.default.ISSUE_ASSIGNEDTO]: {
        key: QueryFieldKey_1.default.ISSUE_ASSIGNEDTO,
        fieldType: BasicFieldType_1.default.RELATED_SPT,
        label: () => lib_i18n_1.default.t('assignee'),
    },
    [QueryFieldKey_1.default.ISSUE_STATUS]: {
        key: QueryFieldKey_1.default.ISSUE_STATUS,
        fieldType: StaticFieldType_1.default.ISSUE_STATUS,
        label: () => lib_i18n_1.default.t('status'),
    },
    [QueryFieldKey_1.default.ISSUE_DUESTATUS]: {
        key: QueryFieldKey_1.default.ISSUE_DUESTATUS,
        fieldType: StaticFieldType_1.default.ISSUE_DUESTATUS,
        label: () => lib_i18n_1.default.t('due-status'),
    },
    [QueryFieldKey_1.default.ISSUE_RESOLUTIONTIME]: {
        key: QueryFieldKey_1.default.ISSUE_RESOLUTIONTIME,
        fieldType: StaticFieldType_1.default.ISSUE_RESTIME,
        label: () => lib_i18n_1.default.t('time-to-resolve'),
    },
    [QueryFieldKey_1.default.ISSUE_FLAG]: {
        key: QueryFieldKey_1.default.ISSUE_FLAG,
        fieldType: StaticFieldType_1.default.ISSUE_FLAG,
        label: () => lib_i18n_1.default.t('priority'),
    },
    [QueryFieldKey_1.default.ISSUE_HASOP]: {
        key: QueryFieldKey_1.default.ISSUE_HASOP,
        fieldType: BasicFieldType_1.default.BOOLEAN,
        label: () => lib_i18n_1.default.t('has-assoc-op'),
    },
    [QueryFieldKey_1.default.ISSUE_TYPE]: {
        key: QueryFieldKey_1.default.ISSUE_TYPE,
        fieldType: StaticFieldType_1.default.ISSUE_TYPE,
        label: () => lib_i18n_1.default.t('type'),
    },
    [QueryFieldKey_1.default.ISSUE_OCCURRENCEDATE]: {
        key: QueryFieldKey_1.default.ISSUE_OCCURRENCEDATE,
        fieldType: BasicFieldType_1.default.DATE,
        label: () => lib_i18n_1.default.t('occurrence-date'),
    },
    [QueryFieldKey_1.default.ISSUE_DEADLINEDATE]: {
        key: QueryFieldKey_1.default.ISSUE_DEADLINEDATE,
        fieldType: BasicFieldType_1.default.DATE,
        label: () => lib_i18n_1.default.t('deadline-date'),
    },
    [QueryFieldKey_1.default.ISSUE_CLOSEDDATE]: {
        key: QueryFieldKey_1.default.ISSUE_CLOSEDDATE,
        fieldType: BasicFieldType_1.default.DATE,
        label: () => lib_i18n_1.default.t('closed-date'),
    },
    [QueryFieldKey_1.default.ISSUE_CAUSES]: {
        key: QueryFieldKey_1.default.ISSUE_CAUSES,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('causes'),
    },
    [QueryFieldKey_1.default.ISSUE_CORRECTIVEACTIONS]: {
        key: QueryFieldKey_1.default.ISSUE_CORRECTIVEACTIONS,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('corrective-actions'),
    },
    [QueryFieldKey_1.default.ISSUE_PREVENTATIVEACTIONS]: {
        key: QueryFieldKey_1.default.ISSUE_PREVENTATIVEACTIONS,
        fieldType: BasicFieldType_1.default.DATE,
        label: () => lib_i18n_1.default.t('preventative-actions'),
    },
};
exports.default = exports.IssueQueryFields;
